import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', // Cambiado de min-height a height fijo
      width: '100vw',
      backgroundColor: '#f4f6f9',
      overflow: 'hidden', // IMPORTANTE: previene scroll en el contenedor raíz
    }}>
      
      {/* Sidebar con altura fija y scroll interno */}
      <div style={{
        width: sidebarCollapsed ? '78px' : '250px',
        height: '100vh', // Altura fija igual a la ventana
        transition: 'width 0.3s ease',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden', // Contiene el scroll interno
      }}>
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
        />
      </div>

      {/* Contenedor principal */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100vh', // Altura fija
        overflow: 'hidden', // IMPORTANTE
      }}>
        
        {/* Navbar fijo */}
        <div style={{
          flexShrink: 0,
          width: '100%'
        }}>
          <Navbar 
            sidebarCollapsed={sidebarCollapsed}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
        </div>

        {/* Contenedor del contenido con scroll interno */}
        <div style={{
          flex: 1,
          minHeight: 0, // CRUCIAL: Permite que se reduzca
          padding: '10px',
          overflow: 'auto', // Scroll interno solo aquí
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;